import { render, staticRenderFns } from "./UserRolesOverview.vue?vue&type=template&id=d0b395de&scoped=true&"
import script from "./UserRolesOverview.vue?vue&type=script&lang=js&"
export * from "./UserRolesOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserRolesOverview.vue?vue&type=style&index=0&id=d0b395de&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b395de",
  null
  
)

export default component.exports